import React from 'react';
import './App.css';
import {
  Alert,
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Grid,
  Box,
  Paper,
  Card,
  TextField,
  CardContent,
  CardMedia, List, ListItem, ListItemText, ListItemIcon
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import { WorldMap } from './components/world_map';
import { InfoPanel } from './components/info_panel';


function envAsString() {
  if (window.location.hostname.startsWith("rk-devbox1")) {
    return "dev"
  }

  else if (window.location.hostname.includes("omniinc.app")) {
    return "prod"
  }

  throw new Error(
    JSON.stringify(["envAsString not implemented for this environment",
      "hostname: " + window.location.hostname]))

}


const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#ff4081',
    },
  },
});


function App() {
  return (
    <div className="App">
      <WorldMap />
      <InfoPanel />
    </div>
  );
}


export default App;
